import type {RouteObject} from 'react-router-dom';
import {createBrowserRouter} from 'react-router-dom';

import HomeRedirect from '@/components/HomeRedirect';
import RootErrorElement from '@/components/router/RootErrorElement';
import clients from '@/features/clients';
import entitlements from '@/features/entitlements';
import events from '@/features/events';
import inventory from '@/features/inventory';
import login from '@/features/login';
import medication from '@/features/medication';
import notEntitled from '@/features/notEntitled';
import notFound from '@/features/notFound';
import pairedDevices from '@/features/pairedDevices';
import relative from '@/features/relative';
import releases from '@/features/releases';
import residents from '@/features/residents';
import rooms from '@/features/rooms';
import root, {RootPage} from '@/features/root';
import settings from '@/features/settings';
import systemDesign from '@/features/system-design';
import tasks from '@/features/tasks';
import today from '@/features/today';
import users from '@/features/users';
import workTime from '@/features/work-time';

const homeRoute: RouteObject = {
  element: <HomeRedirect />,
  index: true,
};

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <RootErrorElement />,
    loader: root.rootLoader,
    element: (
      <RootPage
        menuItems={[
          ...today.menuItems,
          ...tasks.menuItems,
          ...events.menuItems,
          ...residents.menuItems,
          ...relative.menuItems,
          ...rooms.menuItems,
          ...inventory.menuItems,
          ...users.menuItems,
          ...workTime.menuItems,
          ...pairedDevices.menuItems,
          ...medication.menuItems,
          ...settings.menuItems,
          ...clients.menuItems,
          ...entitlements.menuItems,
          ...systemDesign.menuItems,
        ]}
      />
    ),
    children: [
      homeRoute,
      ...notFound.routes,
      ...notEntitled.routes,
      ...today.routes,
      ...tasks.routes,
      ...events.routes,
      ...residents.routes,
      ...relative.routes,
      ...releases.routes,
      ...rooms.routes,
      ...inventory.routes,
      ...users.routes,
      ...medication.routes,
      ...pairedDevices.routes,
      ...settings.routes,
      ...clients.routes,
      ...entitlements.routes,
      ...systemDesign.routes,
      ...workTime.postAccessRoutes,
    ],
  },
  ...workTime.preAccessRoutes,
  ...login.routes,
]);

export default router;
